import { render, staticRenderFns } from "./PartnerAccount.vue?vue&type=template&id=428908b2&scoped=true&"
import script from "./PartnerAccount.vue?vue&type=script&lang=js&"
export * from "./PartnerAccount.vue?vue&type=script&lang=js&"
import style0 from "./PartnerAccount.vue?vue&type=style&index=0&id=428908b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428908b2",
  null
  
)

export default component.exports